import React from 'react';
import PropTypes from 'prop-types';
import { SegmentedControl, SegmentedControlItem } from 'web-ui-components/lib/molecules/forms';
import contentPropTypes from './AccountPicker.content';

const AccountPickerToggleAccountsView = ({ showFavourites, onShowFavourites, onShowAllAccounts, content }) => (
	<div data-test-id="account-picker-header-accountsViewToggle" className="account-picker__header__accountsViewToggle">
		<SegmentedControl>
			<SegmentedControlItem
				checked={showFavourites}
				id="accountpicker-header-show-favourites"
				onClick={onShowFavourites}
			>
				{' '}
				{content.favourites}
			</SegmentedControlItem>
			<SegmentedControlItem
				checked={!showFavourites}
				id="accountpicker-header-show-accounts"
				onClick={onShowAllAccounts}
			>
				{content.allAccounts}
			</SegmentedControlItem>
		</SegmentedControl>
	</div>
);

AccountPickerToggleAccountsView.propTypes = {
	showFavourites: PropTypes.bool.isRequired,
	onShowFavourites: PropTypes.func.isRequired,
	onShowAllAccounts: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes),
};

export default AccountPickerToggleAccountsView;
